<!-- Dialog: Info -->
@if(view && view.canShow['info']) {
  <p-dialog
    header="Detalle del registro"
    [(visible)]="view.canShow['info']"
    (onShow)="scrollToTop()"
    [modal]="true">

    <div [style.width.vw]="80">
      @if (beforeFormContent || content) {
        <ng-container
          [ngTemplateOutlet]="beforeFormContent ?? content ?? null"
          [ngTemplateOutletContext]="{ $implicit: previousData }">
        </ng-container>
      }

      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        (hideDialog)="view.hide('info')">
      </app-reactive-form-builder>

      @if (afterFormContent) {
        <ng-container
          [ngTemplateOutlet]="afterFormContent"
          [ngTemplateOutletContext]="{ $implicit: previousData }">
        </ng-container>
      }
    </div>
  </p-dialog>
}

<!-- Dialog: Delete -->
@if (view && view.canShow['delete']) {
  <p-dialog
    header="Eliminar registro"
    [(visible)]="view.canShow['delete']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="80">
      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        [recordHasAssociatedData]="recordHasAssociatedData"
        [getRequest]="getRequest"
        [request]="deleteRequest"
        (hideDialog)="view.hide('delete')">
      </app-reactive-form-builder>
    </div>
  </p-dialog>
}

<!-- Dialog: Generate -->
@if (view && view.canShow['generate']) {
  <p-dialog
    header="Generar Word"
    [(visible)]="view.canShow['generate']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="50" class="generate-dialog-content">
      <app-generate-modal
        [model]="previousData"
        (hideDialog)="view.hide('generate')">
      </app-generate-modal>
    </div>
  </p-dialog>
}

<!-- Dialog: Generate file -->
@if (view && view.canShow['generateFile']) {
  <p-dialog
    header="Generar archivo"
    [(visible)]="view.canShow['generateFile']"
    (onShow)="scrollToTop()"
    (onHide)="onGenerateFileClosed()">

    <div [style.width.vw]="50" class="generate-dialog-content">
      @if (generateFileContent) {
        <ng-container
          [ngTemplateOutlet]="generateFileContent"
          [ngTemplateOutletContext]="{ $implicit: previousData }">
        </ng-container>
      }
    </div>
  </p-dialog>
}

<!-- Dialog: PAC import -->
@if (view && view.canShow['importPAC']) {
  <app-finca-pac-upload-dialog
    [visible]="view.canShow['importPAC'] ?? false"
    (visibleChange)="setDialogVisibility('importPAC', $event)"
    [finca]="finca"
    (refreshRequested)="refreshRequested.emit()"
  ></app-finca-pac-upload-dialog>
}

<!-- Dialog: CUE send -->
@if (view && view.canShow['sendCUE']) {
  <app-finca-cue-dialog
    [visible]="view.canShow['sendCUE'] ?? false"
    (visibleChange)="setDialogVisibility('sendCUE', $event)"
    [finca]="finca"
    (refreshRequested)="refreshRequested.emit()"
  ></app-finca-cue-dialog>
}

<!-- Dialog: REA import -->
@if (view && view.canShow['importREA']) {
  <app-rea-import-modal
    [visible]="view.canShow['importREA'] ?? false"
    (visibleChange)="setDialogVisibility('importREA', $event)"
    [model]="reaModel"
    [historicoREA]="historicoREA"
    (imported)="onReaImported($event)"
  ></app-rea-import-modal>
}


<!-- Dialog: Reusable chart -->
@if (view && chartConfiguration && view.canShow[chartModalKey]) {
  <p-dialog
    [header]="chartConfiguration.title"
    [visible]="view.canShow[chartModalKey] ?? false"
    (visibleChange)="setDialogVisibility(chartModalKey, $event)"
    (onShow)="scrollToTop()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '70vw' }"
    [breakpoints]="{ '1200px': '82vw', '960px': '92vw', '640px': '98vw' }"
    styleClass="app-reusable-chart-dialog">

    <div class="reusable-chart-dialog-content">
      @if (chartConfiguration.loading) {
        <div class="chart-loading-state">
          <img src="assets/icon/load.gif" alt="Cargando gráfica">
        </div>
      } @else if (hasChartData) {
        <div class="chart-scroll-wrapper">
          <p-chart
            class="responsive-chart"
            [type]="chartConfiguration.type"
            [data]="chartConfiguration.data"
            [options]="chartConfiguration.options">
          </p-chart>
        </div>
      } @else {
        <div class="chart-empty-state">
          {{ chartConfiguration.emptyMessage }}
        </div>
      }
    </div>

    <ng-template pTemplate="footer">
      <button class="btn btn-dark mx-2" type="button" (click)="view.hide(chartModalKey)">
        Cerrar
      </button>
    </ng-template>
  </p-dialog>
}
